export default __webpack_public_path__ + "static/media/logo.d4c303a0.png";